/* RESPONSIBLE TEAM: team-inbox */
import type AppService from 'embercom/services/app-service';
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import ajax from 'embercom/lib/ajax';
import type Session from 'embercom/services/session';

export default class LogService extends Service {
  @service declare appService: AppService;
  @service declare session: Session;

  get appId() {
    let app =
      this.appService.app || (this.session.isWorkspaceLoaded ? this.session.workspace : null);
    return app?.id;
  }

  log(message: string | Record<string, unknown>) {
    return ajax({
      type: 'POST',
      url: '/ember/log',
      data: JSON.stringify({
        app_id: this.appId,
        message,
      }),
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    logService: LogService;
    'log-service': LogService;
  }
}
